package com.eladfinish.bible.contest.screens.main.data

import androidx.compose.ui.graphics.vector.ImageVector
import dev.icerock.moko.resources.ImageResource

/**
 * Icon for a main-screen [ButtonData]: either a moko-resources [ImageResource]
 * (the common case, drawables shared with iOS) or a Compose [ImageVector]
 * (e.g. a Material icon, when there's no dedicated drawable).
 */
sealed interface ButtonIcon {
    data class Resource(val imageResource: ImageResource) : ButtonIcon
    data class Vector(val imageVector: ImageVector) : ButtonIcon
}
